<mat-dialog-content>
  {{question}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close i18n>Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial i18n>Confirm</button>
</mat-dialog-actions>
